import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants, IMenuOption } from './models';
import { SidebarService } from './services';

import { AuthenticationService } from './services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'CLVSMISINTMORUI';

  menu: IMenuOption[]; // Contiene las opciones del menu que se mostraran
  //perms: PermissionModel[]; // Almacena los permisos del usuario
  //currentSession: any; // Sesion actual del usuario
  opened = true; // Estado del menu lateral
  sidebarMode = 'push'; // Model en el que se encuentra en el menu

  date: string;

  constructor(private sidebarService: SidebarService,
    private router: Router,  
    private authenticationService: AuthenticationService
    // private authService: AuthenticationService,
    // private permsService: PermsService
    ) {
    this.date = new Date().toDateString();
    this.sidebarService.isToggled.subscribe(next => {
      this.opened = next;
    });
    // this.authService.currentUser.subscribe(next => {
    //   this.currentSession = next;
    //   if (this.currentSession) this.getPerms();
    // });
    console.log('setOptionsMenu');
    this.setOptionsMenu();
  }

  openedChange($event) {
    this.menu.forEach(x => {
      if (x.Expanded) x.Expanded = false;
    });
  }

  setOptionsMenu(): void {
    this.menu = AppConstants.GetMenu;
  }

  // // Obtiene los permisos que usuario tiene
  // getPerms(): void {
  //   this.permsService.GetPerms().subscribe(next => {
  //     if (next.result) {
  //       this.perms = next.PermsList;
  //       this.setPerms();
  //     }
  //   });
  // }

  // // Establece los permisos de acceso a los menus que el usuario tiene
  // setPerms(): void {
  //   this.menu.forEach(x => {
  //     x.Children.forEach(y => {
  //       this.perms.forEach(z => {
  //         if (z.Name === y.RequiredPerm) y.Visible = z.Active;
  //       })
  //     });
  //   })
  // }

  // Retorna las opciones del menu disponibles
  availableMenuOptions(): IMenuOption[] {
    return this.menu.filter(x => x.Visible);
  }

  // Retorna los submenus que el usuario puede accedar
  availableSubMenuOptions(children: IMenuOption[]): IMenuOption[] {
    return children.filter(x => x.Visible);
  }

  // Evento de cada item menu
  onClickMenuOption(option: IMenuOption, parentOption?: IMenuOption) {

    if (option.Children.length > 0) option.Expanded = !option.Expanded;

    this.menu.forEach(x => {
      x.Selected = false;
      if (x.Children.length > 0) {
        x.Children.forEach(y => y.Selected = false);
      }
    });

    if (option.Name === 'Salir') this.logOut();
    else {
      option.Selected = true;
      if (parentOption) parentOption.Selected = true;
      if (option.Children.length === 0) this.router.navigateByUrl(option.Route);
    }

  }

  logOut() {
    this.opened = false;
    this.authenticationService.logout();
  }
}
